export const ARTICLE_ACTION_MODE = {
  INTERACTIVE: 'interactive',
  READ_ONLY: 'read-only'
} as const;

export const MAX_CART_ARTICLE_QUANTITY = 9999;

export type ArticleActionMode = (typeof ARTICLE_ACTION_MODE)[keyof typeof ARTICLE_ACTION_MODE];

export const ARTICLE_GROUP = {
  PHOTOS: 'photos',
  PIXUM: 'pixum',
  CUPS: 'cups',
  PHOTOBOOKS: 'photobooks',
  CANVAS: 'canvas',
  POSTER: 'poster',
  CALENDAR: 'calendar'
} as const;

export const ARTICLE_TYPE = {
  ARTICLE: 'article',
  GROUP: 'group'
} as const;
